var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subheader shadow-sm"},[_c('div',{staticClass:"d-flex subheader-navbar"},[_c('vue-navigation-bar',{attrs:{"options":_vm.navbarOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }